import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=51827775&scoped=true"
import script from "./Report.vue?vue&type=script&lang=ts"
export * from "./Report.vue?vue&type=script&lang=ts"
import style0 from "./Report.vue?vue&type=style&index=0&id=51827775&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51827775",
  null
  
)

export default component.exports